import React from "react";
import { t } from "../../../components/CustomComponent.js";
import HomeMedia from "./HomeMedia.js";
import HomeFav from "./HomeFav.js";
import HomeCardContact from "./HomeCardContact.js";
import ICON from "../icons.js";
import { homeStatusMeta } from "../options.js";

/* ============================================================================
 * HomePropertyCard — การ์ดทรัพย์ 1 ใบ
 *
 * ใช้ร่วมกันระหว่าง "ทรัพย์แนะนำ" ในหน้าแรกกับหน้ารายการทรัพย์เต็ม
 * (เดิมการ์ดเขียนอยู่ใน HomeFeatured ที่เดียว พอมีหน้ารายการเพิ่มมาจะกลายเป็น
 *  การ์ดสองชุดที่ต้องแก้คู่กันทุกครั้ง จึงแยกออกมาเป็นคอมโพเนนต์เดียว)
 *
 * ป้ายมุมซ้ายบนบอกสถานะจริงของทรัพย์ (ว่าง / ติดจอง / ขายแล้ว ฯลฯ) ไม่ใช่ป้ายโฆษณา
 * ผู้ใช้จะได้ไม่เสียเวลากดทรัพย์ที่ปิดดีลไปแล้ว
 * ========================================================================== */
export default function HomePropertyCard({ item, favorite, pop, onFavorite, onOpen }) {
  const isLand = item.type === "land";
  const status = homeStatusMeta(item.status);

  return (
    <article className="hm-card" onClick={() => onOpen && onOpen(item)}>
      <div className="hm-card__media">
        <HomeMedia src={item.src} kind={item.kind} tone={item.tone} ratio={0.66} alt={item.name} />
        <div className="hm-card__badges">
          <span className={`hm-badge hm-badge--${status.color}`}>{t(status.label)}</span>
        </div>
      </div>

      <div className="hm-card__body">
        <div className="hm-card__head">
          <div className="hm-card__head-text">
            <h3 className="hm-card__title">{item.name}</h3>
            <div className="hm-card__loc">{item.zone}</div>
          </div>
          <HomeFav active={!!favorite} pop={!!pop} onClick={() => onFavorite && onFavorite(item.id)} />
        </div>

        <div className="hm-card__specs">
          {isLand ? (
            <span className="hm-card__spec">
              <span className="hm-ico">{ICON.area}</span>
              {Number(item.area || 0).toLocaleString()} {t("home_unit_sqw")}
            </span>
          ) : (
            <>
              <span className="hm-card__spec">
                <span className="hm-ico">{ICON.bed}</span>
                {item.bed} {t("home_unit_bed")}
              </span>
              <span className="hm-card__spec">
                <span className="hm-ico">{ICON.bath}</span>
                {item.bath} {t("home_unit_bath")}
              </span>
              <span className="hm-card__spec">
                <span className="hm-ico">{ICON.area}</span>
                {item.area} {t("home_unit_sqm")}
              </span>
            </>
          )}
        </div>

        <div className="hm-card__price">
          {item.price_text}
          {item.price_unit && <span>{t(item.price_unit)}</span>}
        </div>
      </div>

      {/* ผู้ติดต่อของประกาศ — ปิดท้ายการ์ดเพื่อให้ติดต่อได้โดยไม่ต้องเปิดหน้ารายละเอียด */}
      <HomeCardContact contact={item.contact} />
    </article>
  );
}
